import React, { useEffect, useState } from "react";
import { ApiGetCall } from "../../JS/Connector";
import { LogInSchoolID } from "../../JS/Common";
import AlertPopup from "../../Components/AlertPopup";

export default function ContactsAccordion({ contacts, setContacts, errors, fromadminorschool, staffEmails, methodOfContact, contactInformation, setContactInformation, handleContactChange, deletePopup, setDeletePopup }) {
    const [newContactType, setNewContactType] = useState("0");
    const [AccessDevice, setAccessDevice] = useState([]);
    const [ConfirmationOtherModal, setConfirmationOtherModal] = useState("");
    const [allowOtherUsers, setAllowOtherUsers] = useState(false);
    const [selectedOtherContactId, setSelectedOtherContactId] = useState(null);
    const [otherPermissions, setOtherPermissions] = useState({});
    const handleMethodOfContactCheckboxChange = (e, id) => {
        setContactInformation((prevState) => {
            const existingUsage = prevState?.methodOfContact ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                methodOfContact: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleOtherMethodOfContactCheckboxChange = (e, id, contactId) => {
        setContacts((prevState) => {
            if (!Array.isArray(prevState)) return [];

            return prevState.map((contact) => {
                if (contact.id !== contactId) return contact; // leave others unchanged

                const existingUsage = contact.method_of_contact ?? [];
                const isChecked = e.target.checked;
                const idString = String(id);

                return {
                    ...contact,
                    method_of_contact: isChecked
                        ? [...new Set([...existingUsage.map(String), idString])]
                        : existingUsage.filter((item) => String(item) !== idString)
                };
            });
        });
    };
    useEffect(() => {
        ApiGetCall(`/schools/profile/staff/access-types?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setAccessDevice(responseRs);
            }
        });
    }, [])

    const AddNewContactType = () => {
        if (newContactType == "0") return;

        const typeMap = {
            1: "Secondary",
            2: "Repair",
            3: "Billing"
        };
        // Dont't Delete this commented code!
        // const maxId = prevContacts.length > 0
        // ? Math.max(...prevContacts.map(c => c.id))
        // : 0;
        setContacts([
            ...contacts,
            {
                id: contacts[contacts.length - 1]?.id + 1 || 1,
                type: typeMap[newContactType],
                typeId: parseInt(newContactType),
                email: "",
                firstname: "",
                lastname: "",
                jobtitle: "",
                phonenumber: "",
                contactextension: "",
                phonetype: "",
                methodOfContact: [],
                AddDeleteFlag: 1,
                isNew: true,
            }
        ]);
        setNewContactType("0");
    };

    return (
        <>
            <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 mt-3'>
                <div className='row '>
                    <div className="pb-3">
                        <b >Main Contact</b>
                    </div>
                    <div className="col-xl-4 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Email<label className='redText'>*</label></div>
                        <select disabled={contactInformation.isNew == false} required={true} value={contactInformation.email} name='email'
                            onChange={(e) => {
                                const selectedEmail = e.target.value;
                                const selectedStaff = staffEmails.find((item) => item.email == selectedEmail);

                                setContactInformation({
                                    ...contactInformation,
                                    email: selectedEmail,
                                    firstname: selectedStaff?.first_name || "",
                                    lastname: selectedStaff?.last_name || ""
                                });
                            }}>
                            <option value="0">Select</option>
                            {staffEmails?.map((item, i) => {
                                return <option key={i} value={item.email} defaultChecked={contactInformation.email}>{item.email}</option>
                            })}
                        </select>
                        <span className="form-text invalid-feedback" >
                            *required
                        </span>
                    </div>
                    {contactInformation.email == "other" &&
                        <>
                            <div className="col-xl-4 col-12 pt-3 ">
                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Choose Access Type{fromadminorschool != 2 && <label className='redText'>*</label>}</div>
                                <select required={fromadminorschool != 2}
                                    value={contactInformation.accesstype} name='email'
                                    onChange={(e) => setContactInformation({
                                        ...contactInformation,
                                        accesstype: e.target.value
                                    })}>
                                    <option value="0">Select</option>
                                    {AccessDevice.map((item, i) => {
                                        return <option value={item.id} key={i}>{item.name} </option>
                                    })}
                                </select>
                                <span className="form-text invalid-feedback" >
                                    *required
                                </span>
                            </div>
                            <div className="col-xl-4 col-12 pt-3 ">
                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Enter Email{fromadminorschool != 2 && <label className='redText'>*</label>}</div>
                                <input type="text" required={fromadminorschool != 2} autoComplete='off'
                                    value={contactInformation.otheremail} onChange={(e) => setContactInformation({ ...contactInformation, otheremail: e.target.value })}
                                    name='email' className="form-control" />
                                <span className="form-text invalid-feedback" >
                                    *required
                                </span>
                            </div>
                        </>
                    }
                    <div className="col-xl-4 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>First Name{contactInformation.email == "other" && <label className='redText'>*</label>}</div>
                        <input type="text" disabled={contactInformation.email != "other"} autoComplete='off' value={contactInformation.firstname}
                            name='firstname' required={contactInformation.email == "other"} className="form-control" onChange={(e) => setContactInformation({ ...contactInformation, firstname: e.target.value })} />
                        <span className="form-text invalid-feedback" >
                            *required
                        </span>
                    </div>
                    <div className="col-xl-4 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Last Name{contactInformation.email == "other" && <label className='redText'>*</label>}</div>
                        <input type="text" disabled={contactInformation.email != "other"} autoComplete='off' value={contactInformation.lastname}
                            name='lastname' className="form-control" required={contactInformation.email == "other"} onChange={(e) => setContactInformation({ ...contactInformation, lastname: e.target.value })} />
                        <span className="form-text invalid-feedback" >
                            *required
                        </span>
                    </div>
                    <div className="col-xl-4 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Job Title</div>
                        <input type="text" autoComplete='off' name='jobtitle' className="form-control"
                            value={contactInformation.jobtitle} onChange={(e) => setContactInformation({ ...contactInformation, jobtitle: e.target.value })} />
                    </div>
                    <div className="col-xl-3 pe-0 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number</div>
                        <input type="text" autoComplete='off' name='phonenumber' className="form-control"
                            value={contactInformation.phonenumber}
                            onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                setContactInformation({ ...contactInformation, phonenumber: onlyNumbers });
                            }} />
                    </div>
                    <div className="col-xl-1 col-12 pt-3 ps-0">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                        <input type="text" autoComplete='off' name='billingextension' className="form-control"
                            value={contactInformation.contactextension}
                            onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                setContactInformation({ ...contactInformation, contactextension: onlyNumbers });
                            }}
                        />
                    </div>
                    <div className="col-xl-4 col-12 pt-3 ">
                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Type</div>
                        <select name='phonetype' value={contactInformation.phonetype} onChange={(e) => setContactInformation({ ...contactInformation, phonetype: e.target.value })}>
                            <option value="0">Select</option>
                            <option value="1">Work</option>
                            <option value="2">Mobile</option>
                            <option value="3">Other</option>
                        </select>
                    </div>
                    <div className="col-xl-8 col-12 pt-3 ">
                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                            <div className='col-12 text-start px-1 new-font-style'>Preferred Method Of Contact</div>
                            <div className='col-md-12 font-13 ps-3 d-flex'>
                                {methodOfContact.map((contact, index) => (
                                    <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                        <input
                                            id={`contactmethod-${contact.id}`}
                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                            type="checkbox"
                                            name='contactmethod'
                                            aria-label={contact.id}
                                            checked={contactInformation?.methodOfContact?.includes(String(contact.id)) || false}
                                            onChange={(e) => handleMethodOfContactCheckboxChange(e, contact.id)}
                                        />
                                        <label htmlFor={`contactmethod-${contact.id}`}
                                            className={`form-check-label ${contactInformation?.methodOfContact?.includes(String(contact.id)) ? 'fw-bold' : ''
                                                }`}>
                                            {contact.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <span className="Emailinvalid" >
                                {errors.selectedMethodOfContactError}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* DYNAMIC CONTACTS */}
            {Array.isArray(contacts) && contacts?.filter(contact => contact.AddDeleteFlag !== 2)?.map((contact, index) => (
                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} key={index} className='p-2 mt-3'>

                    <div className="row">
                        <div className="d-flex justify-content-between pb-3">
                            <b>{contact.type} Contact</b>
                            <img
                                src="/images/DeleteIcon.svg"
                                title="Delete Part"
                                className="img-fluid cursor-pointer"
                                onClick={() => { setDeletePopup({ ...deletePopup, show: !deletePopup.show, item: contact }) }}
                            />
                        </div>
                        <div className="col-xl-4 col-12 pt-3">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Email</div>
                            <select disabled={contact.isNew == false} value={contact.email} name='email'
                                onChange={(e) => {
                                    const selectedEmail = e.target.value;
                                    if (selectedEmail === "other") {
                                        setSelectedOtherContactId(contact.id);
                                        setConfirmationOtherModal(true);
                                        handleContactChange(contact.id, "email", "other"); // keep it as other
                                        handleContactChange(contact.id, "firstname", "");
                                        handleContactChange(contact.id, "lastname", "");
                                        handleContactChange(contact.id, "accesstype", "");
                                    } else {
                                        handleContactChange(contact.id, "email", selectedEmail);
                                        const selectedStaff = staffEmails.find((item) => item.email === selectedEmail);
                                        handleContactChange(contact.id, "firstname", selectedStaff?.first_name || "");
                                        handleContactChange(contact.id, "lastname", selectedStaff?.last_name || "");
                                        handleContactChange(contact.id, "accesstype", selectedStaff?.access_type || "");
                                    }
                                }}>
                                <option value="0">Select</option>
                                {staffEmails?.map((item, i) => {
                                    const isUsedAsSecondary = contacts.some(
                                        (c) => c.type === contact.type && c.email === item.email && c.id !== contact.id
                                    );
                                    return (
                                        <option
                                            key={i}
                                            value={item.email}
                                            disabled={isUsedAsSecondary}
                                            defaultChecked={contactInformation.email}
                                        >
                                            {item.email}
                                        </option>
                                    )
                                })
                                }
                                <option value="other">Other</option>
                                {contact.contact_id == null && contact.isNew == false
                                    && <option value={contact.email} >{contact.email}</option>
                                }
                            </select>
                        </div>
                        {contact.email == "other" && otherPermissions[contact.id] &&
                            <div className="col-xl-4 col-12 pt-3 ">
                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Choose Access Type{fromadminorschool != 2 && <label className='redText'>*</label>}</div>
                                <select required={fromadminorschool != 2}
                                    value={contact.accesstype} name='accesstype'
                                    onChange={(e) =>
                                        handleContactChange(contact.id, "accesstype", e.target.value)
                                    }>
                                    <option value="0">Select</option>
                                    {AccessDevice.map((item, i) => {
                                        return <option value={item.id} key={i}>{item.name} </option>
                                    })}
                                </select>
                                <span className="form-text invalid-feedback" >
                                    *required
                                </span>
                            </div>
                        }
                        {contact.email == "other" &&
                            <div className="col-xl-4 col-12 pt-3 ">
                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Enter Email{fromadminorschool != 2 && <label className='redText'>*</label>}</div>
                                <input type="text" required={fromadminorschool != 2} autoComplete='off'
                                    value={contact.otheremail} onChange={(e) => handleContactChange(contact.id, "otheremail", e.target.value)}
                                    name='email' className="form-control" />
                                <span className="form-text invalid-feedback" >
                                    *required
                                </span>
                            </div>
                        }

                        <div className="col-xl-4 col-12 pt-3">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>First Name{contact.email == "other" && <label className='redText'>*</label>}</div>
                            <input type="text" disabled={contact.email != "other"}
                                required={contact.email == "other"} autoComplete='off'
                                value={contact.firstname} name='firstname' className="form-control"
                                onChange={(e) => handleContactChange(contact.id, "firstname", e.target.value)}
                            />
                            <span className="form-text invalid-feedback" >
                                *required
                            </span>
                        </div>
                        <div className="col-xl-4 col-12 pt-3">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Last Name{contact.email == "other" && <label className='redText'>*</label>}</div>
                            <input type="text" disabled={contact.email != "other"}
                                required={contact.email == "other"} autoComplete='off'
                                value={contact.lastname} name='lastname' className="form-control"
                                onChange={(e) => handleContactChange(contact.id, "lastname", e.target.value)}
                            />
                            <span className="form-text invalid-feedback" >
                                *required
                            </span>
                        </div>
                        <div className="col-xl-4 col-12 pt-3 ">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Job Title</div>
                            <input type="text" autoComplete='off' name='jobtitle' className="form-control"
                                value={contact.jobtitle} onChange={(e) => handleContactChange(contact.id, "jobtitle", e.target.value)} />
                        </div>
                        <div className="col-xl-3 pe-0 col-12 pt-3 ">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number</div>
                            <input type="text" autoComplete='off' name='phonenumber' className="form-control"
                                value={contact.phonenumber}
                                onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                    handleContactChange(
                                        contact.id,
                                        "phonenumber",
                                        onlyNumbers
                                    )
                                }} />
                        </div>
                        <div className="col-xl-1 col-12 pt-3 ps-0">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                            <input type="text" autoComplete='off' name='billingextension' className="form-control"
                                value={contact.contactextension}
                                onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                    handleContactChange(
                                        contact.id,
                                        "contactextension",
                                        onlyNumbers
                                    )
                                }}
                            />
                        </div>
                        <div className="col-xl-4 col-12 pt-3 ">
                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Type</div>
                            <select name='phonetype' value={contact.phonetype} onChange={(e) => handleContactChange(contact.id, "phonetype", e.target.value)}>
                                <option value="0">Select</option>
                                <option value="1">Work</option>
                                <option value="2">Mobile</option>
                                <option value="3">Other</option>
                            </select>
                        </div>
                        <div className="col-xl-8 col-12 pt-3 ">
                            <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                <div className='col-12 text-start px-1 new-font-style'>Preferred Method Of Contact</div>
                                <div className='col-md-12 font-13 ps-3 d-flex'>
                                    {methodOfContact.map((item, index) => (
                                        <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                            <input
                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                type="checkbox"
                                                name='contactmethod'
                                                checked={contact?.method_of_contact?.includes(String(item.id)) || false}
                                                onChange={(e) => handleOtherMethodOfContactCheckboxChange(e, item.id, contact.id)}
                                            />
                                            <label
                                                className={`form-check-label ${contact?.method_of_contact?.includes(String(item.id)) ? 'fw-bold' : ''
                                                    }`}>
                                                {item.name}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            {/* Add new contact type */}
            <div div className="row py-2 align-items-center" >
                <div className="col-xl-4 col-12 pt-3 ">
                    <div>Add New Contact</div>
                    <select
                        value={newContactType}
                        onChange={(e) => setNewContactType(e.target.value)}
                    >
                        <option value="0">Select Contact Type</option>
                        <option value="1">Secondary</option>
                        <option value="2">Repair</option>
                        <option value="3">Billing</option>
                    </select>
                </div>
                {
                    newContactType !== "0" && (
                        <div className="col-xl-4 col-12 pt-5">
                            <button className="BorderBtn text-center" onClick={AddNewContactType}>
                                Add
                            </button>
                        </div>
                    )
                }
            </div>
            <AlertPopup
                isshow={ConfirmationOtherModal}
                img={'/images/greenInfo.svg'}
                headingtext={'Do you want to allow access permissions for adding other users?'}
                text={''}
                cancelcall={() => {
                    setConfirmationOtherModal(false);
                    setOtherPermissions(prev => ({ ...prev, [selectedOtherContactId]: false }));
                }}
                canceltext={"No"}
                successtext={"Yes"}
                successcall={() => {
                    setConfirmationOtherModal(false);
                    setOtherPermissions(prev => ({ ...prev, [selectedOtherContactId]: true }));
                }}
                btntype={'SaveBtn'}
            />

        </>
    )
}
